import { useEffect, useState } from "react";
import patientController from "../../../../apis/Controllers/PatientController/patient.controller";
import { useLocation, useNavigate } from "react-router";
import taskController from "../../../../apis/Controllers/TaskController/task.controller";
import { Toaster } from "../../../Helper/toaster/Toaster";
import reportsController from "../../../../apis/Controllers/ReportsController/reports.controller";
import vitalsController from "../../../../apis/Controllers/VitalsController/vitals.controller";
import Validation from "../../../Helper/validations/vaildation";

const PatientDetailFunctions = () => {
    var breadcrumData = ["Dashboard", "Patient List"];
    var breadcrumItem = "Patient Details";
    const defaultValues = {
        temperature: "",
        weight: "",
        heartbeat: "",
        bloodPressureTop: "",
        bloodPressureBottom: "",
        oxygenSaturationTop: "",
        oxygenSaturationBottom: "",
        bloodSuger: "",
    };
    const defaultErrors = {
        heartbeat: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        weight: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        temperature: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        bloodPressureTop: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        bloodPressureBottom: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        oxygenSaturationTop: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        oxygenSaturationBottom: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
        bloodSuger: {
            rules: ["required", "numeric"],
            isValid: true,
            message: "",
        },
    };

    const [isError, setError] = useState(defaultErrors);
    const [values, setValues] = useState(defaultValues);
    const [showLogin, setShowLogin] = useState(false);
    const [showUpdateVitalModal, setShowUpdateVitalModal] = useState(false);
    const [currentTab, setCurrentTab] = useState("1");
    const [patientData, setPatientData] = useState(null);
    const [medicalRecordTags, setMedicalRecordTags] = useState(null);
    const [patientReportsList, setPatientReportsList] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [vitalsList, setVitalsList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [loader2, setLoader2] = useState(false);
    const [active, setActive] = useState(false);
    // -------------------PAZINATION ----------------------
    const [itemsPerPage, setItemsPerPage] = useState(5);
    //<--------------------Task Pazination---------------------------
    const [page, setPage] = useState(1);
    const [taskListCount, setTaskListCount] = useState(0);
    const [taskListTotalPages, setTaskListTotalPages] = useState([]);

    //----------------------Reports Pazination------------------------
    const [reportsPage, setReportPage] = useState(1);
    const [reportListCount, setReportListCount] = useState(0);
    const [reportListTotalPages, setReportListTotalPages] = useState([]);

    //<----------------------Health Pazination-----------------------------
    const [vitalsPage, setVitalsPage] = useState(1);
    const [vitalsListCount, setVitalsListCount] = useState(0);
    const [vitalsListTotalPages, setVitalsListTotalPages] = useState([]);

    //<--------------------------------------------------------------
    let navigate = useNavigate();
    const loaction = useLocation();

    const tabs = [
        {
            id: 1,
            tabTitle: "Task",
        },
        {
            id: 2,
            tabTitle: "Reports",
        },
        {
            id: 3,
            tabTitle: "Lab",
        },
        {
            id: 4,
            tabTitle: "Health",
        },
        {
            id: 5,
            tabTitle: "Logs",
        },
        {
            id: 6,
            tabTitle: "Medicine",
        },
    ];

    useEffect(() => {
        if (patientData && patientData.cases && patientData.cases.length > 0) {
            let cases = patientData.cases
            let activeCase = null
            for (let i in cases) {
                if (cases[i].status === 1) {
                    activeCase = cases[i]
                }
            }
            if (activeCase) {
                const data = activeCase.tag ? activeCase.tag.replace(/,/g, "") : "";
                let tag = data.split(" ");
                setMedicalRecordTags(tag);
            }
            else {
                setMedicalRecordTags(null);
            }
        } else {
            setMedicalRecordTags(null);
        }
    }, [patientData]);


    const handleTabData = (tabId) => {                    //<-------------onChange Tab
        if (parseInt(tabId) === 1) {
            getTaskListing(1, '');
        } else if (parseInt(tabId) === 2) {
            getReportsListng(1);
        } else if (parseInt(tabId) === 4) {
            getHealthListing(1);
        } else return;
    };


    const getPatientDetail = async (patinetId) => {
        setLoader(true);
        let response = await patientController.patientDetail(patinetId);
        if (response && response.status) {
            let data = response.data.vitals[0];
            setPatientData(response.data);
            setLoader(false);
            setValues({
                ...values,
                temperature: data && data.temperature ? data.temperature : null,
                weight: data && data.weight ? data.weight : null,
                heartbeat: data && data.heart_beat ? data.heart_beat : null,
                bloodPressureTop:
                    data && data.blood_pressure_top
                        ? data.blood_pressure_top
                        : null,
                bloodPressureBottom:
                    data && data.blood_pressure_bottom
                        ? data.blood_pressure_bottom
                        : null,
                oxygenSaturationTop:
                    data && data.oxygen_saturation_top
                        ? data.oxygen_saturation_top
                        : null,
                oxygenSaturationBottom:
                    data && data.oxygen_saturation_bottom
                        ? data.oxygen_saturation_bottom
                        : null,
                bloodSuger: data && data.blood_suger ? data.blood_suger : null,
            });
            getTaskListing(1, response.data.id);
        } else {
            setPatientData(null);
            setLoader(false);
        }
    };

    const taskCompletedByAdmin = async (item) => {
        let patientId = loaction && loaction.state && loaction.state.id ? loaction.state.id
            : "";
        setLoader(true);
        let id = item && item.id ? item.id : "";
        let response = await taskController.taskComplete(id);
        if (response && response.status) {
            getTaskListing(page, '');
            new Toaster().success(response.message);
            getPatientDetail(patientId);
            setLoader(false);
        } else {
            new Toaster().error(response.error);
            setLoader(false);
        }
    };

    //---------------------------------Report module--------------------------------------------------------------->

    const getReportsListng = async (page) => {
        let post = {
            patient_id: patientData && patientData.id ? [patientData.id] : [],
            page: page ? page : 1,
            limit: 5
        };
        setLoader2(true);
        let response = await reportsController.reportsListing(post);
        if (response && response.status) {
            setReportListCount(response.count);
            setPatientReportsList(response.data);
            setLoader2(false);
        } else {
            setPatientReportsList(null);
            setLoader2(false);
        }
    };

    const handleDeleteReport = async (reportId) => {
        let id = reportId ? reportId : "";
        setLoader2(true);
        let response = await reportsController.reportDelete(id);
        if (response && response.status) {
            new Toaster().success(response.message);
            getReportsListng(reportsPage);
            setLoader2(false);
        } else {
            new Toaster().error(response.error);
            setLoader2(false);
        }
    };

    const handleAddReport = async (values) => {
        let response = await reportsController.reportsCreate(
            values,
            patientData
        );
        if (response && response.status) {
            new Toaster().success(response.message);
            getReportsListng(1);
            setLoader2(false);
            return response;
        } else {
            new Toaster().error(response.error);
            setLoader2(false);
            return null;
        }
    };

    //<------------PAZINATION ReportListing-----------------------------

    useEffect(() => {
        if (reportListCount) {
            handleReportsPages(reportListCount);
        }
    }, [reportListCount]);


    const handleReportsPage = (e) => {
        setReportPage(e);
        getReportsListng(e);
    };


    const handleReportsPages = (count) => {
        let array = []
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setReportListTotalPages(array);
    };


    const handleReportsBackClick = () => {
        if (reportsPage > 1) {
            let newpage = reportsPage - 1;
            setReportPage(reportsPage - 1);
            getReportsListng(newpage);
        } else return;
    };



    const handleReportsNextClick = () => {
        if (reportsPage >= 1 && reportsPage < reportListTotalPages.length) {
            let newpage = reportsPage + 1;
            setReportPage(reportsPage + 1);
            getReportsListng(newpage);
        } else return;
    };

    //--------------------------Task module-------------------------------------------------------------------------->

    const getTaskListing = async (page, id) => {
        let post = {
            patient_id: id ? id : patientData && patientData.id ? patientData.id: null,
            page: page ? page : 1,
            limit: 5
        };
        setLoader2(true);
        let response = await taskController.taskListingPatientDetails(post);
        if (response && response.status) {
            setTaskListCount(response.count);
            setTaskList(response.data);
            setLoader2(false);
        } else {
            setLoader2(false);
            setTaskList([]);
        }
    };

    //<------------PAZINATION TaskListing----------------------------------------------

    useEffect(() => {
        if (taskListCount) {
            handleTaskListPages(taskListCount);
        }
    }, [taskListCount]);


    const handlePage = (e) => {
        setPage(e);
        getTaskListing(e, '');
    };


    const handleTaskListPages = (count) => {
        let array = []
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setTaskListTotalPages(array);
    };

    const handleTaskBackClick = () => {
        if (page > 1) {
            let newpage = page - 1;
            setPage(page - 1);
            getTaskListing(newpage, '');
        } else return;
    };


    const handleTaskNextClick = () => {
        if (page >= 1 && page < taskListTotalPages.length) {
            let newpage = page + 1;
            setPage(page + 1);
            getTaskListing(newpage, '');
        } else return;
    };


    //-----------------------Health module------------------------------------------------------------->

    const getHealthListing = async (page) => {
        let post = {
            patient_id: patientData && patientData.id ? [patientData.id] : [],
            page: page ? page : 1,
            limit: 5
        };
        setLoader2(true);
        let response = await vitalsController.vitalsListing(post);
        if (response && response.status) {
            setLoader2(false);
            setVitalsListCount(response.count);
            setVitalsList(response.data);
        } else {
            setLoader2(false);
            setVitalsList([]);
        }
    };


    const handleChange = (field, value) => {
        let validation = new Validation(isError);
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        setValues({ ...values, [field]: value });
    };


    const updateHealth = async () => {
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values);
        if (isValid && !isValid.haveError) {
            let response = await vitalsController.updateVitals(
                patientData,
                values
            );
            if (response && response.status) {
                new Toaster().success(response.message);
                setShowUpdateVitalModal(false);
                getHealthListing(vitalsPage);
                setActive(true);
            }
            else{
                new Toaster().error(response.error); 
            }
        } else {
            setError({ ...isValid.errors });
        }
    };


    //<--------------------------------HEALTH Pazination ------------------------------

    useEffect(() => {
        if (vitalsListCount) {
            handleHealthListPages(vitalsListCount);
        }
    }, [vitalsListCount]);


    const handleHealthPage = (e) => {
        setVitalsPage(e);
        getHealthListing(e);
    };


    const handleHealthListPages = (count) => {
        let array = []
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setVitalsListTotalPages(array);
    };


    const handleHealthBackClick = () => {
        if (vitalsPage > 1) {
            let newpage = vitalsPage - 1;
            setVitalsPage(newpage);
            getHealthListing(newpage);
        } else return;
    };


    const handleHealthNextClick = () => {
        if (vitalsPage >= 1 && vitalsPage < vitalsListTotalPages.length) {
            let newpage = vitalsPage + 1;
            setVitalsPage(newpage);
            getHealthListing(newpage);
        } else return;
    };


    return {
        breadcrumData,
        breadcrumItem,
        navigate,
        loaction,
        showUpdateVitalModal,
        setShowUpdateVitalModal,
        showLogin,
        setShowLogin,
        currentTab,
        setCurrentTab,
        tabs,
        getPatientDetail,
        patientData,
        breadcrumItem,
        loader,
        loader2,
        medicalRecordTags,
        taskCompletedByAdmin,
        patientReportsList,
        handleTabData,
        handleDeleteReport,
        handleAddReport,
        getTaskListing,
        taskList,
        vitalsList,
        values,
        isError,
        handleChange,
        getHealthListing,
        updateHealth,
        active,
        page,
        handlePage,
        setItemsPerPage,
        taskListCount,
        handleTaskBackClick,
        handleTaskNextClick,
        handleReportsPage,
        handleReportsBackClick,
        handleReportsNextClick,
        handleHealthPage,
        handleHealthBackClick,
        handleHealthNextClick,
        reportsPage,
        vitalsPage,
        taskListTotalPages,
        reportListTotalPages,
        vitalsListTotalPages
        // setBreadcrumItem,
    };
};

export default PatientDetailFunctions;
